import { render, staticRenderFns } from "./NewBranchInvoice.vue?vue&type=template&id=246137f5&scoped=true"
import script from "./NewBranchInvoice.vue?vue&type=script&lang=js"
export * from "./NewBranchInvoice.vue?vue&type=script&lang=js"
import style0 from "./NewBranchInvoice.vue?vue&type=style&index=0&id=246137f5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246137f5",
  null
  
)

export default component.exports